import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withTranslation } from 'react-i18next';

class MuestraAlerta extends React.Component {
  handleClose = () => {
    this.props.handleDialog();
  };

  handleEnd = () => {
    this.props.handleReset();
  };

  render() {
    const { mostrarDialogo, tituloDialogo, mensajeDialogo, valoresDialogo, detalleDialogo, valoresDetalleDialogo, t, botonContinuar, botonTerminar } = this.props;
    // console.log("mostrarDialogo", mostrarDialogo);
    // console.log("valoresDialogo", valoresDialogo);
    
    return (
      <div>
        <Dialog
          open={mostrarDialogo}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ zIndex: 3000000000}}
        >
          <DialogTitle id="alert-dialog-title">{t(tituloDialogo)}</DialogTitle>
          <DialogContent>
            {mensajeDialogo.map((error, i) => {
              return (
                <DialogContentText key={i} id="alert-dialog-description">
                  {t(error)} { (valoresDialogo[i] !== 'undefined') ? valoresDialogo[i] : ''}
                </DialogContentText>
              );
            })}
          </DialogContent>
          {detalleDialogo && detalleDialogo.length > 0 &&
            <DialogContent dividers>
              {detalleDialogo.map((error, i) => {
                return (
                  <DialogContentText key={i} id="alert-dialog-description" style={{display: 'inline'}}>
                    {t(error)} {+ ' ' + (valoresDetalleDialogo[i] !== undefined) ? valoresDetalleDialogo[i] + ' ' : ' '}
                  </DialogContentText>
                );
              })}
            </DialogContent>
          }
          <DialogActions>
            <Button onClick={this.handleEnd} color="primary" autoFocus>
              {t(botonTerminar)}
            </Button>
            <Button onClick={this.handleClose} color="primary" variant="contained">
              {t(botonContinuar)}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withTranslation('pagos')(MuestraAlerta);
